<div class="row mt-2">
    <div class="col-md-8">
      <div class="card">
          <div class="card-header">
              <div class="card-title mb-0"><strong>Page</strong></div>
          </div>
          <div class="card-body">
              <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="title" class="form-label">Title <em>*</em></label>
                            <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.title" required>
                            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                                <div *ngIf="name.errors.required">Name is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="page_identifier" class="form-label">Page Identifier <em>*</em></label>
                            <input type="text" class="form-control" id="page_identifier" name="page_identifier" #page_identifier="ngModel" [(ngModel)]="data.page_identifier" required>
                            <div *ngIf="f.submitted && page_identifier.invalid" class="invalid-feedback">
                                <div *ngIf="page_identifier.errors.required">Page Identifier is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="language" class="form-label">Language <em>*</em></label>
                            <select class="form-control" id="language" name="language" #language="ngModel" [(ngModel)]="data.language" required>
                                <option [value]="'en'">English</option>
                                <option [value]="'cn'">Chinese</option>
                                <option [value]="'my'">Malay</option>
                            </select>
                            <div *ngIf="f.submitted && language.invalid" class="invalid-feedback">
                                <div *ngIf="language.errors.required">Language is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                  <div class="row">
                      <div class="col-12">
                          <div class="mb-3">
                              <label for="status" class="form-label">Status <em>*</em></label>
                              <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                                  <option [value]="1">Active</option>
                                  <option [value]="0">Disabled</option>
                              </select>
                              <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                  <div *ngIf="status.errors.required">Status is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="content" class="form-label">Content</label>
                            <angular-editor id="content" [placeholder]="'Content'" [(ngModel)]="data.content" ></angular-editor>
                        </div>
                    </div>
                </div>
                  <button type="submit" class="btn btn-primary">Update</button>
              </form>
          </div>
      </div>
    </div>
  </div>